import React from 'react';
import ReactDOM from 'react-dom';
import './LoadingModal.css';

interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({
  isOpen,
  message = 'Processing...'
}) => {
  if (!isOpen) return null;

  // Split message by newlines for multiline support
  const messageLines = message.split('\n');

  return ReactDOM.createPortal(
    <div className="loading-modal-overlay">
      <div className="loading-modal">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
        <div className="loading-message">
          {messageLines.map((line, index) => (
            <p key={index} className="loading-message-line">{line}</p>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LoadingModal;